// libs
import React from 'react';

import platform from '@lyearn/core/utils/Platform';
import { ChevronDown } from '@lyearn/icons';
import { cn, StyleSheet } from '@lyearn/style';
// components
import { Button, Typography } from '@lyearn/ui';

import { ActionButtonProps } from '.';

export const style = StyleSheet.create({
  actionButton: {
    maxWidth: 280,
    paddingLeft: 12,
    paddingRight: 8,
    paddingTop: 0,
    paddingBottom: 0,
  },
});

const ActionButtonMobile = React.forwardRef(
  (
    { children, isSelected = false, isOpen, onClick, endIcon }: ActionButtonProps,
    ref: React.Ref<HTMLButtonElement> | undefined,
  ) => {
    const activeState = isSelected || isOpen;
    const isWeb = platform.OS === 'web';

    return (
      <Button
        key={children?.toString()}
        ref={ref}
        appearance="secondary"
        className={cn(
          'flex flex-grow-0 items-center justify-center border-2 border-solid bg-s-info-light',
          activeState ? '' : 'border-s-info-light',
        )}
        endIcon={
          <ChevronDown
            className={cn('h-16 w-16', isWeb ? '-ms-6' : '-ms-12')}
            fillColorToken={activeState ? 'icon-primary' : 'icon-secondary'}
            style={{ height: 16, width: 16 }}
          />
        }
        size="x-small"
        style={style.actionButton}
        typography={{ variant: 'body-short-02' }}
        variant="filled"
        onClick={onClick}>
        <Typography
          className="flex items-center truncate"
          color="text-text-paragraph"
          variant={activeState ? 'label-02' : 'body-short-02'}>
          {children}
        </Typography>
      </Button>
    );
  },
);

export default ActionButtonMobile;
